let rootStyle;
let windowWidth;

function updateContentWidth() {
	const tab = document.getElementById("td-toptab");
	if (tab) {
		rootStyle.setProperty("--tab-height", `${tab.getBoundingClientRect().height}px`);
	}
}

function setScrollOffsets() {
	const scrollElt = document.body;
	if (scrollElt) {
		const contentWidth = scrollElt.scrollWidth;
		if (window.scrollX !== 0) {
			if (window.scrollX <= contentWidth - windowWidth) {
				rootStyle.setProperty("--scroll-left", `${window.scrollX}px`);
			} else {
				rootStyle.setProperty("--scroll-left", `${contentWidth - windowWidth + (window.innerWidth - windowWidth)}px`);
			}
		} else {
			rootStyle.setProperty("--scroll-left", 0);
		}
	}
}

function onResize() {
	windowWidth = document.documentElement.clientWidth;
	updateContentWidth();
}

function init() {
	rootStyle = document.documentElement.style;
	windowWidth = document.documentElement.clientWidth;
	updateContentWidth();

	if (window.scrollX !== 0 && window.scrollY === 0) {
		window.scrollTo(window.scrollX + 1, window.scrollY);
	} else if (window.scrollX === 0 && window.scrollY !== 0) {
		window.scrollTo(window.scrollX, window.scrollY + 1);
	} else if (window.scrollX !== 0 && window.scrollY !== 0) {
		window.scrollTo(window.scrollX + 1, window.scrollY + 1);
	}

	window.addEventListener("scroll", () => window.setTimeout(setScrollOffsets, 0));
	window.addEventListener("resize", () => onResize);

	const portrait = window.matchMedia("(orientation: portrait)");
	portrait.addEventListener("change", () => {
		onResize();
		setScrollOffsets();
	});
}

export { init };